import { chessPieces } from './chessPieces-sidecar'
import { chessUiGame } from './ui/chessUiGame-sidecar'
import { chessUiMenuMain } from './ui/chessUiMenuMain-sidecar'

export function* generator_menuMain(): Generator<number, number, number> {
  chessUiMenuMain.setOpen(true)
  chessUiGame.setOpen(false)
  chessPieces.killAll()

  while (true) {
    yield 0
  }
  return 0
}
